import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Offer from "./Offer";
import { WarehousePrices } from "./WarehousePrices";
import { CountryState } from "./CountryState";
import Model from "./Model";
export class Country extends Model {
  constructor(country = {}) {
    super();
    _defineProperty(this, "id", {
      fieldName: 'country_id',
      content: null
    });
    _defineProperty(this, "Id", {
      fieldName: 'country_id',
      content: null
    });
    _defineProperty(this, "CountryId", {
      fieldName: 'country_id',
      content: null
    });
    _defineProperty(this, "CountryCountryStates", {
      fieldName: 'country_country_state',
      model: CountryState,
      content: null
    });
    _defineProperty(this, "CountryCode", {
      fieldName: 'country_code',
      content: null
    });
    _defineProperty(this, "CountryCurrencyName", {
      fieldName: 'country_currency_name',
      content: null
    });
    _defineProperty(this, "CountryCurrencyCode", {
      fieldName: 'country_currency_code',
      content: null
    });
    _defineProperty(this, "CountryCurrencySymbol", {
      fieldName: 'country_currency_symbol',
      content: null
    });
    _defineProperty(this, "name", {
      fieldName: 'country_name',
      content: null
    });
    _defineProperty(this, "CountryName", {
      fieldName: 'country_name',
      content: null
    });
    _defineProperty(this, "CountryPhoneCode", {
      fieldName: 'country_phone_code',
      content: null
    });
    _defineProperty(this, "CountryWarehousePrices", {
      fieldName: 'country_warehouse_prices',
      model: WarehousePrices,
      content: null
    });
    _defineProperty(this, "CountryOffers", {
      fieldName: 'country_offers',
      model: Offer,
      content: null
    });
    _defineProperty(this, "CountryEmoji", {
      fieldName: 'country_emoji',
      content: null
    });
    _defineProperty(this, "CountryI18n", {
      fieldName: 'country_i18n',
      content: null
    });
    let id = country === null || country === void 0 ? void 0 : country.id;
    let name = country === null || country === void 0 ? void 0 : country.name;
    let emoji = country === null || country === void 0 ? void 0 : country.emoji;
    if (id) this.Id.content = id;
    if (name) this.CountryName.content = name;
    if (emoji) this.CountryEmoji.content = emoji;
  }
  getId() {
    var _this$Id;
    return (_this$Id = this.Id) === null || _this$Id === void 0 ? void 0 : _this$Id.content;
  }
  getName() {
    var _this$CountryName$con;
    return (_this$CountryName$con = this.CountryName.content) !== null && _this$CountryName$con !== void 0 ? _this$CountryName$con : this.name.content;
  }
  getEmoji() {
    return this.CountryEmoji.content;
  }
  getCountryId() {
    var _this$CountryId;
    return (_this$CountryId = this.CountryId) === null || _this$CountryId === void 0 ? void 0 : _this$CountryId.content;
  }
  getCode() {
    return this.CountryCode.content;
  }
  getCountryFlag() {
    var _this$CountryEmoji;
    return (_this$CountryEmoji = this.CountryEmoji) === null || _this$CountryEmoji === void 0 ? void 0 : _this$CountryEmoji.content;
  }
  getCurrencySymbol() {
    return this.CountryCurrencySymbol.content;
  }
  getCurrencyCode() {
    return this.CountryCurrencyCode.content;
  }
  getI18nNames() {
    var _this$CountryI18n;
    return (_this$CountryI18n = this.CountryI18n) === null || _this$CountryI18n === void 0 ? void 0 : _this$CountryI18n.content;
  }
  getCountryTranslation(lang) {
    var _lang$split$, _lang$split, _this$getI18nNames$la, _this$getI18nNames;
    let langSplit = (_lang$split$ = lang === null || lang === void 0 || (_lang$split = lang.split) === null || _lang$split === void 0 || (_lang$split = _lang$split.call(lang, '-')) === null || _lang$split === void 0 ? void 0 : _lang$split[0]) !== null && _lang$split$ !== void 0 ? _lang$split$ : 'en';
    return (_this$getI18nNames$la = (_this$getI18nNames = this.getI18nNames()) === null || _this$getI18nNames === void 0 || (_this$getI18nNames = _this$getI18nNames[langSplit]) === null || _this$getI18nNames === void 0 ? void 0 : _this$getI18nNames['country_i18n_name']) !== null && _this$getI18nNames$la !== void 0 ? _this$getI18nNames$la : this.getName();
  }
  getNameTranslation(lang) {
    return this.getCountryTranslation(lang);
  }
  getNameTranslationWithEmoji(lang) {
    return [this.getEmoji(), this.getCountryTranslation(lang)].join('&nbsp;');
  }
  getCountryPhoneCode() {
    var _this$CountryPhoneCod;
    return (_this$CountryPhoneCod = this.CountryPhoneCode) === null || _this$CountryPhoneCod === void 0 ? void 0 : _this$CountryPhoneCod.content;
  }
  getPhoneCode() {
    var _this$CountryPhoneCod2;
    return (_this$CountryPhoneCod2 = this.CountryPhoneCode) === null || _this$CountryPhoneCod2 === void 0 ? void 0 : _this$CountryPhoneCod2.content;
  }
  getCountrySelectObject(text = 'text', value = 'value', otherFields = [], local = 'en') {
    var _this$CountryId2;
    let item = {
      [text !== null && text !== void 0 ? text : 'text']: this.getCountryTranslation(local),
      [value !== null && value !== void 0 ? value : 'value']: (_this$CountryId2 = this.CountryId) === null || _this$CountryId2 === void 0 ? void 0 : _this$CountryId2.content
    };
    if (otherFields.includes('emoji')) item.emoji = this.CountryEmoji.content;
    if (otherFields.includes('country')) item.country = this;
    return item;
  }
  static getListValueKey() {
    return 'Id.content';
  }
  static getListTextKey() {
    return 'CountryName.content';
  }
}
export default Country;